import { type SimpleStore } from '@databases/redux-types';
import { type CommonRootState } from '@databases/utils/redux/redux';

import { collabStateManager } from './collab-state-manager';

/**
 * Calls the given callback, grouping any YJS mutations that happen during its execution to the database
 * with the given content ID into a single YJS transaction. This can be useful to make the undo manager
 * register the change as a single action.
 *
 * If no collab manager is registered for the given database (for example because the app is running on
 * non-collab mode), simply calls the given callback without applying any transaction logic.
 *
 * Does not support async callbacks.
 */
export function collabDatabaseBatch(
  store: SimpleStore<CommonRootState>,
  contentId: string,
  callback: () => void
): void {
  const collabManager = collabStateManager.getCollabManager(contentId);

  if (collabManager) {
    collabManager.batch(callback);
  } else {
    callback();
  }
}
